/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import Switch from "react-switch";
import PropTypes from "prop-types";
import { Tooltip } from "react-tippy";
import t from "../../../utils/translation/translator";
import Spinner from "../../Icons/Spinner/Spinner";

const ToggleInput = ({ label, checked, switchable, loading, minimal, idLabel, ...props }) => (
  <div
    id={`select-filters-toggle-${idLabel}`}
    className="flex space-x-3 items-center text-xs"
    onClick={(e) => {
      if (!switchable) {
        e.stopPropagation();
      }
    }}
  >
    {loading && minimal ? (
      <Spinner small id="loading_spinner" />
    ) : (
      <Tooltip
        title={!switchable ? t("msizer.ui.tooltip.cannot_change_option") : ""}
        position="right"
        duration={200}
        arrow
        size="small"
        theme="light"
      >
        <Switch
          height={28 * 0.75}
          width={56 * 0.75}
          uncheckedIcon={false}
          checkedIcon={false}
          onColor="#008a16"
          offColor="#eee"
          offHandleColor={!switchable ? "#808080" : "#fff"}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.5)"
          checked={checked}
          disabled={!switchable}
          {...props}
        />
      </Tooltip>
    )}
    {label && !minimal && <span className="">{label}</span>}
  </div>
);

ToggleInput.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  switchable: PropTypes.bool,
  loading: PropTypes.bool,
  minimal: PropTypes.bool,
  idLabel: PropTypes.string.isRequired
};

ToggleInput.defaultProps = {
  label: "",
  checked: false,
  switchable: true,
  loading: false,
  minimal: false
};

export default ToggleInput;
